/**
 * @param name
 * @hidden
 */
export function _WarnImport(name) {
    return "".concat(name, " needs to be imported before as it contains a side-effect required by your code.");
}
//# sourceMappingURL=devTools.js.map